import { t } from 'i18next';
import './StepState.css';

function StepStateFormWidget({objectDto}) {
    const stepData = [
        { number: 2, name: t("healthassessment") },
        { number: 3, name: t("fillpersoninfo") },
        { number: 5, name: t("confirminfo") },
        { number: 7, name: t("payfeeassurence") },
      ];
    return (
        <>
        {
            objectDto.step !== undefined && 
            <div className="form-steps-container">
                {stepData.map((step, index) => (
                    <div className="form-step-wrapper" key={step.number}>
                    <div className="form-step">
                        <div className={objectDto.step >= step.number ? "circle-state-done" : "circle-state"}></div>
                        <div className='form-step-name-state'>
                            <p className="form-step-name">{step.name}</p>
                        </div>
                    </div>
                    {index < stepData.length - 1 && <div className={objectDto.step > step.number ? "line-state-done" : "line-state"}></div>}
                    </div>
                ))}
            </div>
        }
        </>
        
    );
}
export default StepStateFormWidget;